<template lang="pug">
  section.characteristics.wrapper-p(data-id=`characteristics`)
    .characteristics__column.characteristics__column--sticky
      .characteristics__content
        .characteristics__image
          base-picture(
            :minScreenWidth="picture.minScreenWidth"
            :desktopName="picture.desktopName"
            :mobileName="picture.mobileName"
            :alt="picture.alt"
          )
          a.characteristics__image-btn.bg-d-blue.clr-white.t-ttu.t-tdn(href=`upload/Центральный бортовой компьютер (ЦБК).pdf` download)
            svg(xmlns=`http://www.w3.org/2000/svg`)
              use(:href="$setSvgHref(`img/sprite.svg#i-file`)")
            | Скачать презентацию

    .characteristics__column.characteristics__column--main
      .characteristics__content
        h2.characteristics__title.t-h2 Технические характеристики

        .characteristics__table
          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ЦПУ
            .characteristics__table-cell
              p.characteristics__text Intel® Atom™ processor Е3827, two cores 1.75GHz

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ОЗУ
            .characteristics__table-cell
              p.characteristics__text 2Гб 1066MHz/1333MHz

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ПЗУ
            .characteristics__table-cell
              p.characteristics__text 1 x 2.5" SATA 2.01 SSD от 64 ГБ

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text LTE
            .characteristics__table-cell
              p.characteristics__text 1 x LTE mPCIe, 2 SIM (опционально) или внешний модем

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ГЛОНАСС/GPS
            .characteristics__table-cell
              p.characteristics__text U-blox NEO-M8N или внешний модем

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ПОРТЫ ВВОДА-ВЫВОДА
            .characteristics__table-cell
              p.characteristics__text 1 x микрофон
              p.characteristics__text 1 x линейный выход
              p.characteristics__text 1 x слот для SD карт с крышкой
              p.characteristics__text 1 x тип A USB 3.0 Host
              p.characteristics__text 1 x 9 ~ 36VDC вход питания
              p.characteristics__text 2 x типа A USB 2.0
              p.characteristics__text 1 x RJ45 10/100/1000 Fast Ethernet с LED
              p.characteristics__text 1 x DB-15 VGA. Разрешение до 2560 x 1600 @60Hz
              p.characteristics__text 1 x DP (порт дисплея). Разрешение до 2560 x 1600 @60Hz
              p.characteristics__text 2 x DB-9 for RS-232
              p.characteristics__text 1 x LHF 60-pin разъём
              p.characteristics__text 1 x 6-pin разъём, 12VDC output (до 1A)
              p.characteristics__text 1 x DB-9 RS-422/485
              p.characteristics__text 3 x DI
              p.characteristics__text 3 x DO.
              p.characteristics__text 1х CAN 2.0B
              p.characteristics__text 1 x CAN/OBDII модуль (CAN Bus 2.0B или OBDII SAE J1939) - опционально

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ОПЕРАЦИОННАЯ СИСТЕМА
            .characteristics__table-cell
              p.characteristics__text Linux (Ubuntu 18.04)

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ГАБАРИТЫ, мм
            .characteristics__table-cell
              p.characteristics__text 180 x 180 x 50, вес 1.7кг

          .characteristics__table-row
            .characteristics__table-cell
              p.characteristics__text ОКРУЖАЮЩАЯ СРЕДА
            .characteristics__table-cell
              p.characteristics__text Эксплуатация:#[br]-35°C .. +70°C относительная влажность до 90%
              p.characteristics__text Хранение:#[br]-40°C .. +85°C относительная влажность до 90%
</template>

<script>
export default {
  data () {
    return {
      picture: {
        minScreenWidth: `1024px`,
        desktopName: `characteristics-image-desktop`,
        mobileName: `characteristics-image-desktop`,
        alt: `Технические характеристики`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .characteristics {
    display: flex;

    @include respond-max(tablet) {
      flex-direction: column-reverse;
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }

  .characteristics__column {
    &--sticky {
      margin-left: -$offset-desktop;

      @include respond-max(tablet) {
        margin-left: 0;
      }
    }

    &--main {
      flex-grow: 1;
      width: 48.5vw;
      margin-left: auto;
      padding-top: 7.81vw;
      padding-bottom: 7.24vw;
      padding-left: 5.65vw;

      @include respond-max(tablet) {
        width: 100%;
        margin-bottom: 2rem;
        padding-top: 0;
        padding-left: 0;
      }
    }
  }

  .characteristics__content {
    .characteristics__column--sticky & {
      position: sticky;
      top: 0;

      @include respond-max(tablet) {
        position: static;
      }
    }
  }

  .characteristics__image {
    position: relative;
    width: 77vh;
    max-width: 41.9vw;
    height: 100vh;

    @include respond-max(tablet) {
      width: 100%;
      max-width: none;
      height: auto;

      picture {
        display: none;
      }
    }
  }

  .characteristics__image-btn {
    @include font('m');
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3rem;
    font-size: 1.3125rem;
    letter-spacing: 0.06em;
    text-align: center;
    transition: $trs;

    svg {
      width: 1.125rem;
      height: 1.40625rem;
      margin-right: 0.875rem;
    }

    &:hover {
      background-color: $blue;
    }

    @include respond-max(tablet) {
      position: static;
    }
  }

  .characteristics__title {
    margin-bottom: 4rem;
  }

  .characteristics__table {
    display: flex;
    flex-direction: column;
    border-top: 2px solid #564e43;
  }

  .characteristics__table-row {
    display: flex;
    border-bottom: 1px solid rgba(#564e43, 0.2);
  }

  .characteristics__table-cell {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 2.625rem;
    padding-bottom: 2.875rem;
    padding-left: 4.125rem;
    padding-right: 1.5rem;

    &:first-of-type {
      flex-shrink: 0;
      width: 30%;
      min-width: 11rem;
      padding-left: 0;
      border-right: 1px solid rgba(#564e43, 0.2);

      @include respond-max(tablet) {
        width: 40%;
        max-width: 12rem;
        min-width: auto;
        word-break: break-word;
      }
    }
  }

  .characteristics__text {
    margin-bottom: 0.5rem;
    font-size: 0.9375rem;
    line-height: 1.2;
    color: #464646;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
</style>
